import { type FC } from "react";

import { PageEventType } from "components/server-types";
import { EventChip } from "worksheets/views/timeline/EventChip";

export type EventMarkerTooltipProps = {
  dateLabel: string;
  eventLabel?: string;
  eventType?: PageEventType.PUBLICATION | PageEventType.SUBMISSION_COLLECTION;
};

export const EventMarkerTooltip: FC<EventMarkerTooltipProps> = ({
  dateLabel,
  eventLabel,
  eventType,
}) => (
  <div className="flex w-max max-w-full flex-col items-start gap-1">
    <p className="body-s whitespace-nowrap text-black-tint-20">{dateLabel}</p>
    {eventType ? (
      <EventChip eventType={eventType} />
    ) : eventLabel ? (
      <p className="body-s min-w-0 max-w-full truncate text-black-tint-20">{eventLabel}</p>
    ) : null}
  </div>
);
